export const USER_ROLE_ACCESS_PAGE_DATA = 'USER_ROLE_ACCESS_PAGE_DATA';
export const USER_ROLE_ACCESS_SET_GROUPS = 'USER_ROLE_ACCESS_SET_GROUPS';
export const USER_ROLE_ACCESS_CLEAR_GROUPS = 'USER_ROLE_ACCESS_CLEAR_GROUPS';
export const USER_ROLE_ACCESS_SET_LOADING = 'USER_ROLE_ACCESS_SET_LOADING';
export const USER_ROLE_ACCESS_SET_ROLES = 'USER_ROLE_ACCESS_SET_ROLES';
export const USER_ROLE_ACCESS_CLEAR_ROLES = 'USER_ROLE_ACCESS_CLEAR_ROLES';
export const USER_ROLE_ACCESS_SET_ROLE_ID = 'USER_ROLE_ACCESS_SET_ROLE_ID';
export const USER_ROLE_ACCESS_CLEAR_ROLE_ID = 'USER_ROLE_ACCESS_CLEAR_ROLE_ID';
export const USER_ROLE_ACCESS_SET_SAVING = 'USER_ROLE_ACCESS_SET_SAVING';
export const USER_ROLE_ACCESS_CLEAR_SAVING = 'USER_ROLE_ACCESS_CLEAR_SAVING';



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/state/types.js